import { Link } from "react-router-dom";
import { AddToCart, AddToWishList, BuyNow } from "../../../../../Constants/Constants";

export const ProductDetailButton = () => {
  return (
    <div className="m-t-15 btn-showcase">
      <Link className="btn btn-primary" to={`${process.env.PUBLIC_URL}/applications/ecommerce/cart`} title="">
        <i className="fa fa-shopping-basket me-1"></i>
        {AddToCart}
      </Link>
      <Link className="btn btn-success" to={`${process.env.PUBLIC_URL}/applications/ecommerce/checkout`} title="">
        <i className="fa fa-shopping-cart me-1"></i>
        {BuyNow}
      </Link>
      <Link className="btn btn-secondary" to={`${process.env.PUBLIC_URL}/applications/ecommerce/wishlist`}>
        <i className="fa fa-heart me-1"></i>
        {AddToWishList}
      </Link>
    </div>
  );
};
